import React, { useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Banner from '../components/layout/Banner';

const useStyles = makeStyles(theme => ({
  gray: {
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#e7e7e8',
    paddingBottom: theme.spacing(5),
  },
  paper: {
    padding: theme.spacing(5)
  },
  portrait: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5)
  },
  grid: {
    marginTop: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(5),
    },
  },
  logo: {
    margin: '0 auto',
    paddingBottom: '60%',
    backgroundPosition: 'left center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
    },
  },
  title: {
    fontSize: '2em',
    lineHeight: '1.25em',
    textTransform: 'uppercase'
  },
  subtitle: {
    fontWeight: 400,
    marginTop: theme.spacing(1)/2,
  },
  eventdate: {
    fontWeight: 400,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    color: theme.palette.secondary.main
  },
  text: {
    whiteSpace: 'pre-line',
    lineHeight: '1.5em',
    marginBottom: theme.spacing(6),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  login: {
    color: theme.palette.secondary.main
  },
  button: {
    minWidth: '100px',
  }
}));

export default (props) => {
  const history = useHistory();

  useLayoutEffect(() => {
    if (props.isAuthenticated) {
      history.push("/event");
    }
  }, [history, props.isAuthenticated]);

  const handleRegister = async (event) => {
    history.push("/register");
  }
  const handleLogin = async (event) => {
    history.push("/login");
  }
  const classes = useStyles();
  return (
    <>
    <div className={classes.gray} style={{ backgroundImage: `url('https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/aeea2020/pinnacles/background.light.png')` }}>
      <Banner isAuthenticated={props.isAuthenticated} Logout={props.Logout} />
      <Container>
      <Grid container direction="row" className={classes.grid} alignItems="center">
        <Grid item xs={12} sm={12} md={6}><div className={classes.logo} style={{ backgroundImage: `url('https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/aeea2020/pinnacles/logo.png')` }}></div></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper className={classes.paper}>
            <h1 className={classes.title}>{props.config.homePanel.title}</h1>
            <h2 className={classes.subtitle}>{props.config.homePanel.subtitle}</h2>
            <h3 className={classes.eventdate}>{props.config.homePanel.eventDate}</h3>
            <p className={classes.text}>{props.config.homePanel.description}</p>
            <Grid container direction="row" alignItems="center" spacing={6}>
              <Grid item xs={8}>
                <h4 className={classes.login}>Login using your AEEA2020 details, to explore the Pinnacles Awards.</h4>
              </Grid>
              <Grid item xs={4} style={{textAlign: 'right'}}>
                <Button color="secondary" variant="contained" onClick={handleLogin} className={classes.button} disableElevation>Login</Button>
              </Grid>
            </Grid>
            <hr  className={classes.divider} />
            <Grid container direction="row" alignItems="center" spacing={6}>
              <Grid item xs={8}>
                <h4 className={classes.login}>Or, if you are a new user, register your details now to join the event.</h4>
              </Grid>
              <Grid item xs={4} style={{textAlign: 'right'}}>
                <Button color="secondary" variant="contained" onClick={handleRegister} className={classes.button} disableElevation>Register</Button>
              </Grid>
            </Grid>

          </Paper>
        </Grid>
      </Grid>
      </Container>
    </div>
  </>
  );
};